<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-28 19:04:17
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\ApprovalProcess\viewAbnormalClockinApprovalProcess.vue
 * @最后编辑: Please set LastEditors
 * @最后修改时间: 2022-05-05 11:30:13
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_approvalProcess_form_abnormalClockinTitle')"
    backgroundClass="transparent"
    widthClass="max-1000"
    pad="0"
  >
    <template v-slot:nav-actions>
      <approvalTools
        v-if="Data && Data['flow_status'] == 1"
        :curUuid="Data['uuid']"
        :staff_uuid="curStaff"
        :flag="Data['cancel_flag']"
        :data_type="Data['data_type']"
        :final_node="Number(Data['is_final_task_node'])"
        :matched="Number(Data['is_match']) ? true : false"
        :canRevoke="Number(Data['is_allow_revoke'])"
        :canRollback="Number(Data['is_allow_rollback'])"
        :canForward="Number(Data['is_allow_forward'])"
        @back="onBack"
        @forward="onForward"
        @approval="onApproval"
        @reject="onReject"
      />
    </template>
    <!-- content -->
    <template v-slot:page-main v-if="Data">
      <ApprovalTriger
        v-if="Data"
        :bg-color="Data.approval_bg_color"
        :slide-color="Data.approval_tint_color"
        @triger="
          $toPage(
            '/admin/approval-process/abnormalClockin-detail/' +
              $route.params.params +
              '/approval-detail/' +
              $route.params.params
          )
        "
      >
        <template v-slot:time>
          {{ $getDateTime(Data.operate_utc_datetime, "YYYY/MM/DD HH:mm") }}
        </template>
        <template v-slot:status>
          {{ $getCommonLangValue(Data.status_detail) }}
        </template>
      </ApprovalTriger>
      <Section>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{
                $t("label_essweb_abnormalClockin_form_swiftNumberLabel")
              }}</v-sheet
            >
            <v-text-field
              readonly
              v-model="Data.swift_number"
              :label="$t('label_essweb_abnormalClockin_form_swiftNumberLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_abnormalClockin_form_submitDateLabel") }}
            </v-sheet>
            <v-text-field
              readonly
              :value="
                $getDateTime(Data.submission_utc_datetime, 'YYYY/MM/DD HH:mm')
              "
              :label="$t('label_essweb_abnormalClockin_form_submitDateLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              label="label_essweb_abnormalClockin_form_applicatLabel"
              v-model="user"
              readonly
              chips
              avatar
              two-line
              small-chips
              :items="users"
              item-value="uuid"
              item-text="preferred_name"
            >
              <template v-slot:selection.avatar="{ data }">
                <StaffAvatar
                  :src="data.item.staff_avatar"
                  left
                  small
                  :isTemp="data.item.is_temp"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:selection="{ data }">
                {{ $getCommonLangValue(data.item.preferred_name) }}
              </template>
            </AutoComplete>
          </v-col>
        </v-row>
      </Section>
      <Section>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_abnormalClockin_form_punchDateLabel") }}
            </v-sheet>
            <v-text-field
              readonly
              :value="$getDateTime(Data.punch_utc_datetime, 'YYYY/MM/DD')"
              :label="$t('label_essweb_abnormalClockin_form_punchDateLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_abnormalClockin_form_actualPunchTimeLabel") }}
            </v-sheet>
            <v-text-field
              readonly
              :value="$getDateTime(Data.punch_utc_datetime, 'HH:mm')"
              :label="
                $t('label_essweb_abnormalClockin_form_actualPunchTimeLabel')
              "
              single-line
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </Section>
      <Section>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12" v-if="Data.attachments">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_abnormalClockin_form_attachmentLabel") }}
            </v-sheet>
            <ImgDragUpdate :defaultImageList="Data.attachments" disabled />
            <!-- <v-list v-if="Data.attachments">
                <v-list-item
                  two-line
                  v-for="(item, index) in Data.attachments"
                  :key="index"
                >
                  <v-list-item-avatar tile>
                    <v-img :src="item"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{item}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>-->
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_abnormalClockin_form_reasonLabel") }}
            </v-sheet>
            <v-text-field
              readonly
              v-model="Data.invalid_reason_text"
              :label="$t('label_essweb_abnormalClockin_form_reasonLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_abnormalClockin_form_messageLabel") }}
            </v-sheet>
            <v-text-field
              readonly
              v-model="Data.remarks"
              :label="$t('label_essweb_abnormalClockin_form_messageLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </Section>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";

import approvalTools from "@/Page/EssAdmin/Approval/ApprovalProcess/components/approvalTools";
export default {
  name: "viewAbnormalClockinApprovalProcess",
  components: { approvalTools },
  computed: {
    ...mapGetters(["AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
  },
  data() {
    return {
      Data: { attachments: [] },
      users: [],
      page_params: null,
      user: null,
    };
  },
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.params)); //解密参数
    this.curStaff = this.curAppInfo["user"]["user_id"];
    this.getDetail();
  },
  methods: {
    onReject: function (comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 4,
          business_action: "terminate",
          cancel_flag: this.Data.cancel_flag,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_reject_rejectSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onApproval: function (comments = "", sender) {
      const that = this;
      let data = {
        uuid: this.page_params.id,
        data_type: 4,
        business_action: "send",
        cancel_flag: this.Data.cancel_flag,
        operate_comment: comments,
      };
      if (sender.length != 0) data["sender_uuid"] = sender.join(",");
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: data,
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_send_approvalSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onForward: function (sender, node, comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 4,
          business_action: "forward",
          cancel_flag: this.Data.cancel_flag,
          sender_uuid: sender,
          business_action_status: node == 0 ? 4 : 3,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_forward_forwardSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onBack: function (sender, comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 4,
          cancel_flag: this.Data.cancel_flag,
          business_action: "back",
          business_action_status: sender == 0 ? 1 : 2,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_back_backSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "unknown",
        url: "/approval-task/get-approval-task-details/",
        data: {
          uuid: this.page_params.id,
          data_type: 4,
          is_approval: 1,
        },
      }).then((res) => {
        that.user = res.data.uuid;
        that.users = [
          {
            staff_avatar: res.data.agent_staff.staff_avatar,
            uuid: res.data.uuid,
            preferred_name: res.data.agent_staff.preferred_name,
          },
        ];
        if (res.data.attachments) {
          res.data["attachments"].map((item) => {
            item["uuid"] = item["uuid"];
            item["file_name"] = item["file_name"];
            item["path"] = item["url"];
            item["size"] = item["attachment_size"];
          });
        } else {
          res.data.attachments = [];
        }
        that.Data = res.data;
      });
    },
  },
};
</script>
